import React from "react";

import { Alert } from "~/components/alert";

import { DocLink } from "../../../../../../../components/react/docLink/DocLink";
import { SILENCING_DOC_LINK_SLUG } from "../../silencing-doc-link-slug";

export function ActiveRuleAlert() {
	return (
		<Alert variant="info">
			<strong className="font-semibold">There is 1 silencing rule</strong> active on this monitor. To learn more about
			unmuting monitors,{" "}
			<DocLink capture="noop" slug={SILENCING_DOC_LINK_SLUG}>
				check out our docs
			</DocLink>
			.
		</Alert>
	);
}
